import * as React from "react";
import { Space } from "antd";
import { BrowserView, MobileView } from "react-device-detect";
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";

import * as String from "../../commons/string";

const ReservationDateInfo = ({ isB2b, rentNo, period }: { isB2b?: boolean; rentNo?: string; period?: string }) => {
    const reservationDates = {
        startDate: {
            name: "출차 시간",
            date: isB2b ? "오후 2시 이후" : "오후 2시 ~ 오후 5시(시간 외 출차 불가)",
        },
        endDate: {
            name: "반납 시간",
            date: isB2b ? "오전 11시까지" : "반납일 오전 11시까지",
        },
    };

    return (
        <>
            <MobileView className="mobile">
                {rentNo && (
                    <Space style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <p>예약 번호</p>
                        <p>{rentNo}</p>
                    </Space>
                )}
                <Space style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <p style={{ textAlign: "right", wordBreak: "keep-all", whiteSpace: "nowrap" }}>{String.rentalDate}</p>
                    <p style={{ textAlign: "right", wordBreak: "keep-all" }}>{period}</p>
                </Space>
                <Space style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <p>{reservationDates.startDate.name}</p>
                    <p>{reservationDates.startDate.date}</p>
                </Space>
                <Space style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <p>{reservationDates.endDate.name}</p>
                    <p>{reservationDates.endDate.date}</p>
                </Space>
            </MobileView>
            <BrowserView className="browser">
                {rentNo && (
                    <Space style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <p>예약 번호</p>
                        <p>{rentNo}</p>
                    </Space>
                )}
                <Space style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <CalendarOutlined style={{ marginRight: "8px" }} />
                        <p>{String.rentalDate}</p>
                    </div>
                    <p>{period}</p>
                </Space>
                <Space style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <ClockCircleOutlined style={{ marginRight: "8px" }} />
                        <p>{reservationDates.startDate.name}</p>
                    </div>
                    <p>{reservationDates.startDate.date}</p>
                </Space>
                <Space style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <p style={{ paddingLeft: "22px" }}>{reservationDates.endDate.name}</p>
                    <p>{reservationDates.endDate.date}</p>
                </Space>
            </BrowserView>
        </>
    );
};

export default ReservationDateInfo;
